import * as React from "react";

// An enum with all the types of actions to use in our reducer
export enum RunRestoreVolumeReducerActionType {
  LOCATION = "LOCATION",
  INDEX = "INDEX",
  NAME = "NAME",
  ZONE = "ZONE",
}

// An interface for our actions
interface RunRestoreVolumeReducerAction {
  type: RunRestoreVolumeReducerActionType;
  payload: any;
}

// An interface for our state
export interface RestoreVolumeReducerState {
  location: string;
  volumeIndex: string;
  snapshotName: string;
  zone?: string;
}

// Our reducer function that uses a switch statement to handle our actions
function runRestoreVolume(state: RestoreVolumeReducerState, action: RunRestoreVolumeReducerAction) {
  const { type, payload } = action;
  switch (type) {
    case RunRestoreVolumeReducerActionType.LOCATION:
      return {
        ...state,
        location: payload,
      };
    case RunRestoreVolumeReducerActionType.INDEX:
      return {
        ...state,
        volumeIndex: payload,
      };
    case RunRestoreVolumeReducerActionType.NAME:
      return {
        ...state,
        snapshotName: payload,
      };
    case RunRestoreVolumeReducerActionType.ZONE:
      return {
        ...state,
        zone: payload,
      };
    default:
      return state;
  }
}

export function useRunRestoreVolumeReducer(
  initialLocation: string | undefined,
  initialVolumeIndex: string | undefined,
  initialSnapshotName: string | undefined,
  initialZone: string | undefined
) {
  const initialState: RestoreVolumeReducerState = {
    location: initialLocation || "",
    volumeIndex: initialVolumeIndex || "",
    snapshotName: initialSnapshotName || "",
    zone: initialZone || "",
  };
  return React.useReducer(runRestoreVolume, initialState);
}
